import { Component, signal } from '@angular/core';
import { DateFilterComponent } from "../../_shared/components";
import { DateIntervalFilterData } from '../../_shared/models';
import { DateInterval } from '../../_shared/enums';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-fuel-performance',
  standalone: true,
  imports: [ DateFilterComponent, TranslocoDirective],
  templateUrl: './fuel-performance.component.html',
  styleUrl: './fuel-performance.component.scss'
})
export class FuelPerformanceComponent {
  protected buttonMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  protected monthToDate = signal<boolean>(false);

  public utilizationDateFilter: DateIntervalFilterData;
  public defaultInterval: DateInterval = DateInterval.Day;
  public disabledIntervals: DateInterval[] = [DateInterval.Month, DateInterval.Half];

  constructor() {
    this.utilizationDateFilter = {} as DateIntervalFilterData;
  }

  onUtilizationDateFilterChange(filter: DateIntervalFilterData): void {
    this.utilizationDateFilter = filter;
  }
}
